import { TemplatePortal } from '@angular/cdk/portal';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { BehaviorSubject, combineLatest, fromEvent, Subject, Subscription } from 'rxjs';

import { OverlayContentService } from 'mojo-batch';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'mojo-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  // tslint:disable:use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class SideNavComponent implements OnInit, OnDestroy, AfterViewInit {
  private readonly irpPluginOpenMessageType = 'IRP_PLUGIN_OPENED';
  private readonly irpCandidateSidenavOpenMessageType = 'IRP_SIDENAV_OPENED';
  @Input() set opened(value: boolean) {
    this.opened$.next(value);
  }
  @Input() drawerEnlarged = false;
  @Input() backdropEnabled = true;

  @Output() closed = new EventEmitter();
  @Output() wentBack = new EventEmitter();

  @ViewChild('portalContent') portalContent: TemplateRef<any>;
  @ViewChild('sidenav') sidenav: MatSidenav;

  opened$ = new BehaviorSubject(false);

  private templatePortal$ = new Subject<TemplatePortal>();
  private subscription: Subscription;

  constructor(
    private overlayContentService: OverlayContentService,
    private viewContainerRef: ViewContainerRef,
    private injector: Injector,
  ) {}

  ngOnInit() {
    this.subscription = combineLatest([this.opened$, this.templatePortal$]).subscribe(
      ([isOpened, portal]) => {
        if (portal && isOpened) {
          this.overlayContentService.setSidebarContent(portal);
          this.notifySideDrawerOpenedForPluginIntegration();
        }
      },
    );
    this.listenToPluginOpened();
  }

  ngAfterViewInit() {
    this.templatePortal$.next(
      new TemplatePortal(this.portalContent, this.viewContainerRef, this.injector),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();

    if (this.opened$.value) {
      this.overlayContentService.setSidebarContent(null);
    }
  }

  goBack() {
    this.wentBack.emit();
    this.close();
  }

  open() {
    this.opened$.next(true);
  }

  close() {
    this.opened$.next(false);
    this.closed.emit();
  }

  toggle() {
    this.opened$.next(!this.opened$.value);
  }

  private listenToPluginOpened() {
    this.subscription.add(
      fromEvent(window, 'message').subscribe((event: MessageEvent) => {
        if (event.data?.type === this.irpPluginOpenMessageType) {
          this.close();
        }
      }),
    );
  }

  private notifySideDrawerOpenedForPluginIntegration() {
    window.postMessage({ type: this.irpCandidateSidenavOpenMessageType }, window.location.origin);
  }
}
